<template>
    <v-progress-circular
        :rotate="-90"
        :size="180"
        :width="15"
        :value="tech.level"
        :color=getColor()
        >
        <v-layout align-content-center text-xs-center>
            <div>
                <div class="headline">{{tech.name}}</div>
                <p>{{tech.type}}</p>
                <p>{{tech.years}} Years</p>
            </div>
        </v-layout>
    </v-progress-circular>
</template>

<script>
export default {
    name: 'Technology',
    props:[
        'tech'
    ],
    methods: {
        getColor(){
            if(this.tech.color){
                return this.tech.color
            }
            return 'black'
        }
    }
}
</script>


